// Berry College's undergraduate majors (#2743). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog (catalog.berry.edu, catoid=30):
// each school's page (Campbell School of Business, Evans School of
// Humanities, Arts and Social Sciences, School of Mathematical and Natural
// Sciences, Charter School of Education and Human Sciences) and the
// Interdisciplinary Programs page, every "Major" line under each department
// kept, minors left out. The Academic Programs page lists the same 79
// programs in one alphabetical list. The catalog lists concentrations as
// separate programs ("Biology Major: Integrative Biology Concentration,
// B.S."), so they stay separate here, named as the catalog names them with
// the degree moved to its own field; one note "(33 hours)" is dropped from
// a name. International Business is a dual major with no degree of its own
// (null). The catalog sits behind a browser check, so it was read in a
// browser. The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "berry-college",
    "read": "2026-10-01",
    "intro": "Every major in Berry's official 2026-2027 Undergraduate Catalog, grouped by the school that offers it, with the degree it leads to. Berry lists each concentration as its own program, and so does this list. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Campbell School of Business",
            "source": {
                "label": "Berry College 2026-2027 Undergraduate Catalog, Campbell School of Business",
                "url": "https://catalog.berry.edu/content.php?catoid=30&navoid=1133"
            },
            "majors": [
                {
                    "name": "Accounting Major",
                    "degree": "B.S."
                },
                {
                    "name": "Finance Major",
                    "degree": "B.S."
                },
                {
                    "name": "Data Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Economics Major",
                    "degree": "B.A."
                },
                {
                    "name": "Economics Major",
                    "degree": "B.S."
                },
                {
                    "name": "Management Major",
                    "degree": "B.S."
                },
                {
                    "name": "International Business Dual Major",
                    "degree": null,
                    "note": "A dual major, taken together with another major."
                },
                {
                    "name": "Marketing Major",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Evans School of Humanities, Arts and Social Sciences",
            "source": {
                "label": "Berry College 2026-2027 Undergraduate Catalog, Evans School of Humanities, Arts and Social Sciences",
                "url": "https://catalog.berry.edu/content.php?catoid=30&navoid=1138"
            },
            "majors": [
                {
                    "name": "Communication Major: Communication & Media Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Major: Digital and Social Media Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Major: Filmmaking & Cinematic Arts Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Major: Public Relations Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Major: Sports Communication Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science and Studies Major: Environmental Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Creative Writing",
                    "degree": "B.A."
                },
                {
                    "name": "English Major",
                    "degree": "B.A."
                },
                {
                    "name": "Art Major: Art Education Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Art Major: Art History Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Art Major: Studio-art Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Music Education",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music Performance",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music with Elective Studies in Business",
                    "degree": "B.Mus."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre Major",
                    "degree": "B.A."
                },
                {
                    "name": "International Affairs Major",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science Major",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science Major",
                    "degree": "B.S."
                },
                {
                    "name": "History Major",
                    "degree": "B.A."
                },
                {
                    "name": "History Plus Major: History Plus Enterprise Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "History Plus Major: History Plus Gender Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "History Plus Major: History Plus Global Issues Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "History Plus Major: History Plus Justice Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "History Plus Major: History Plus Technology Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "History Plus Major: History Plus the Environment Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "History Plus Major: History Plus the Public Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "History Plus Major: History Plus Writing Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Religion and Philosophy Major: Biblical and Christian Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Religion and Philosophy Major: Ethics and Value Theory Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Religion and Philosophy Major: Philosophy Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Religion and Philosophy Major: Religious Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology and Anthropology Major: Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology and Anthropology Major: Anthropology",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology and Anthropology Major: Dual Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology and Anthropology Major: Dual Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology and Anthropology Major: Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology and Anthropology Major: Sociology",
                    "degree": "B.S."
                },
                {
                    "name": "French Major: French Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "French Major: French Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "German Major: German Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "German Major: German Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish Major",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Mathematical and Natural Sciences",
            "source": {
                "label": "Berry College 2026-2027 Undergraduate Catalog, School of Mathematical and Natural Sciences",
                "url": "https://catalog.berry.edu/content.php?catoid=30&navoid=1139"
            },
            "majors": [
                {
                    "name": "Animal Science- Concentration I - Pre-Vet/Pre-Professional Science",
                    "degree": "B.S."
                },
                {
                    "name": "Animal Science- Concentration II - Production/Management",
                    "degree": "B.S."
                },
                {
                    "name": "Biology Major: Cellular and Biomedical Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Biology Major: Integrative Biology Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Biology Major: Wildlife, Ecology, and Conservation Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry Major",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry Major",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science and Studies Major: Environmental Science Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science Major",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics: Applied Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics: Education Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics: Professional Track",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Creative Technologies Major",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Dual-Degree",
                    "degree": "B.S."
                },
                {
                    "name": "Physics Major, General Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics Major, Professional Track",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Charter School of Education and Human Sciences",
            "source": {
                "label": "Berry College 2026-2027 Undergraduate Catalog, Charter School of Education and Human Sciences",
                "url": "https://catalog.berry.edu/content.php?catoid=30&navoid=1140"
            },
            "majors": [
                {
                    "name": "Exercise Science Major",
                    "degree": "B.S."
                },
                {
                    "name": "Sport Leadership and Strategy",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology Major",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology Major",
                    "degree": "B.S."
                },
                {
                    "name": "Education Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary Education Major (P-5)",
                    "degree": "B.S."
                },
                {
                    "name": "Secondary Education Major (6-12 or P-12)",
                    "degree": "B.S.",
                    "note": "A dual major: completed with an approved second major, and you receive the degree that goes with the second major."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                }
            ]
        },
        {
            "name": "Interdisciplinary Programs",
            "source": {
                "label": "Berry College 2026-2027 Undergraduate Catalog, Interdisciplinary Programs",
                "url": "https://catalog.berry.edu/content.php?catoid=30&navoid=1142"
            },
            "majors": [
                {
                    "name": "Individual-Designed Major",
                    "degree": "B.A."
                },
                {
                    "name": "Individual-Designed Major",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
